export const PRODUCT_BY_ID_REQUEST = "PRODUCT_BY_ID_REQUEST";
export const PRODUCT_BY_ID_SUCCESS = "PRODUCT_BY_ID_SUCCESS";
export const PRODUCT_BY_ID_FAIL = "PRODUCT_BY_ID_FAIL";
export const PRODUCT_BY_ID_RESET = "PRODUCT_BY_ID_RESET";

export const ALL_PRODUCTS_LOADING = "ALL_PRODUCTS_LOADING";
export const ALL_PRODUCTS_SUCCESS = "ALL_PRODUCTS_SUCCESS";
export const ALL_PRODUCTS_FAIL = "ALL_PRODUCTS_FAIL";

export const FETCH_SHOP_PRODUCTS_LOADING = "FETCH_SHOP_PRODUCTS_LOADING";
export const FETCH_SHOP_PRODUCTS_SUCCESS = "FETCH_SHOP_PRODUCTS_SUCCESS";
export const FETCH_SHOP_PRODUCTS_FAIL = "FETCH_SHOP_PRODUCTS_FAIL";

export const NEW_REVIEW_REQUEST = "NEW_REVIEW_REQUEST";
export const NEW_REVIEW_SUCCESS = "NEW_REVIEW_SUCCESS";
export const NEW_REVIEW_RESET = "NEW_REVIEW_RESET";
export const NEW_REVIEW_FAIL = "NEW_REVIEW_FAIL";


// productConstants.js

export const FETCH_CATEGORY_PRODUCTS_LOADING = "FETCH_CATEGORY_PRODUCTS_LOADING";
export const FETCH_CATEGORY_PRODUCTS_SUCCESS = "FETCH_CATEGORY_PRODUCTS_SUCCESS";
export const FETCH_CATEGORY_PRODUCTS_FAIL = "FETCH_CATEGORY_PRODUCTS_FAIL";
